<div class="login-page">
  <div class="row g-0 h-100">

    <div class="col-12 col-md-12 col-lg-8 bg-image-container">
      <video #videoPlayer autoplay loop muted playsinline class="bg-video" preload="auto">
        <source src="assets/videos/mncland-shortvideo.mp4" type="video/mp4">
      </video>
    </div>
 
    <!-- Login Form Column -->
    <div class="col-12 col-md-4 col-lg-4 d-flex align-items-center justify-content-center">
      <div class="login-form-container w-100 px-4 px-md-5">
        <!-- Logo and Title -->
        <div class="mb-4 bg-custom">
          <img src="assets/logo/login-logoMTI.png" alt="MTI Logo" class="mb-3" style="max-width: 200px;">
        </div>

        <!-- Login Form -->
        <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
          <!-- Email Input -->
          <div class="mb-3">
            <label for="email" class="form-label">Email Address</label>
            <input type="email" class="form-control" id="email" placeholder="Insert your email address"
              [(ngModel)]="email" name="email" required email #emailInput="ngModel">
            <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)" class="text-danger small mt-1">
              <div *ngIf="emailInput.errors?.['required']">
                Email is required
              </div>
              <div *ngIf="emailInput.errors?.['email']">
                Please enter a valid email address
              </div>
            </div>
          </div>

          <!-- Password Input -->
          <div class="mb-3">
            <label for="password" class="form-label">Password</label>

            <div class="input-group">
              <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password"
                placeholder="Insert your password" [(ngModel)]="password" name="password" required
                #passwordInput="ngModel">
              <div class="input-group-text cursor-pointer" (click)="togglePasswordVisibility()">
                <i class="" [ngClass]="showPassword ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
              </div>
            </div>

            <div *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)"
              class="text-danger small mt-1">

              <div *ngIf="passwordInput.errors?.['required']">
                Password is required
              </div>
            </div>
          </div>

          <div #recaptchaContainer></div>

          <!-- Submit Button -->
          <button type="submit" class="btn btn-primary w-100 py-2" [disabled]="loginForm.invalid">
            Sign In
          </button>
        </form>

      </div>
    </div>
  </div>
</div>